"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseZeroState_1 = require("../../zeroStates/nodeZeroState/baseZeroState");
const isDefaultDate = (timeStamp) => new Date(timeStamp).getTime() === new Date(baseZeroState_1.defaultDate).getTime();
function setStartedOn(state, timeStamp) {
    if (!state.startedOn || isDefaultDate(state.startedOn)) {
        state.startedOn = timeStamp;
    }
}
exports.default = setStartedOn;
//# sourceMappingURL=setStartedOn.js.map